import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  IconButton,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { get_root_value } from "src/utils/domUtils";

const PARAMETER_OPTIONS = [
  "Duration/Pace",
  "Reps",
  "Max_Reps",
  "Watts",
  "Height",
  "Weight",
  "Distance/Calories",
  "Rest",
  "Distance",
  "Time",
  "%MHR",
  "Tempo",
  "Vdot",
  "Pace",
  "RPE",
];

function ParameterModel({ open, setOpen, data, handleChange, reps_for_time }) {
  const [fields, setFields] = useState(PARAMETER_OPTIONS);

  const handleClose = () => setOpen(false);

  const handleTagToggle = (tag) => {
    let newTags = [...data];
    const isSelected = newTags.includes(tag);

    if (!isSelected) {
      if (tag === "Vdot") {
        newTags = ["Vdot", "Distance", "Time"];
      } else if (tag === "Pace") {
        newTags = ["Pace"];
      } else {
        newTags.push(tag);
      }
    } else {
      if (tag === "Vdot" || tag === "Pace") {
        newTags = ["Weight", "Distance/Calories", "Rest"];
      } else {
        newTags = newTags.filter((t) => t !== tag);
      }
    }

    handleChange(newTags);
  };

  useEffect(() => {
    if (open) {
      setFields(PARAMETER_OPTIONS);
    }
  }, [open]);

  const shouldShowTag = (tag) => {
    const isVdot = data.includes("Vdot");
    const isPace = data.includes("Pace");

    if (reps_for_time && (tag === "Reps" || tag === "Max_Reps")) return false;

    if (
      (isVdot || isPace) &&
      ["Distance/Calories", "Duration/Pace"].includes(tag)
    )
      return false;
    if (!isVdot && !isPace && tag === "Time") return false;
    if (!isVdot && tag === "Distance") return false;
    if (isVdot && tag === "RPE") return false;

    return true;
  };

  const renderLabel = (tag) => {
    switch (tag) {
      case "Vdot":
        return "Auto Pacer";
      case "Max_Reps":
        return "Max Reps";
      default:
        return tag;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          backgroundColor: "white",
          color: "black",
          boxShadow: "none",
        },
      }}
    >
      <Box className="d-flex justify-content-between align-items-center mt-1 text-end">
        <DialogTitle
          sx={{
            py: 0,
            color: get_root_value("--portal-theme-primary"),
          }}
        >
          Parameters
        </DialogTitle>
        <IconButton className="me-1 back-screen-button" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      <DialogContent>
        <DialogContentText>
          <div className="row">
            {fields.filter(shouldShowTag).map((tag) => (
              <div className="col-lg-6 col-md-6 col-sm-12" key={tag}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    size="small"
                    checked={data.includes(tag)}
                    onChange={() => handleTagToggle(tag)}
                    sx={{ padding: "5px" }}
                  />
                  <FormControlLabel
                    control={
                      <Typography variant="body2" sx={{ ml: 1 }}>
                        {renderLabel(tag)}
                      </Typography>
                    }
                    label=""
                  />
                </Box>
              </div>
            ))}
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
}

export default ParameterModel;
